import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from '../../axiosConfig';
import '../../styles/ConfirmTrainerRegistration.css';

const ConfirmTrainerRegistration = () => {
    const { trainerId } = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation('auth');
    const [message, setMessage] = useState(t('confirmAccount.confirming'));

    useEffect(() => {
        const confirmTrainerRegistration = async () => {
            try {
                await axios.put(`/api/v1/auth/confirm/${trainerId}`);
                setMessage(t('confirmAccount.success'));
            } catch (error) {
                setMessage(t('confirmAccount.error'));
            }
        };

        confirmTrainerRegistration();
    }, [trainerId, t]);

    return (
        <div className="auth-container">
            <div className="auth-box">
                <h1>{message}</h1>
                <button onClick={() => navigate('/')}>{t('confirmAccount.goToLogin')}</button>
            </div>
        </div>
    );
};

export default ConfirmTrainerRegistration;
